"use strict";
/******************************************************************
 * Copyright @ 2023 广州牛师帮文化科技有限公司. All rights reserverd.
 * @file   src\hooks\useCountdown\index.ts
 * @author 朱剑豪
 * @date   2023/02/16 19:22
 * @desc   倒计时
 ******************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Countdown = void 0;
var react_1 = require("react");
var Countdown;
(function (Countdown) {
    /**
     * 倒计时hook
     *    设置总时长，开始后，每秒更新剩余秒数，触发重绘。
     *    用例：
     *      获取短信验证码后，限制不得60秒内重复获取，并每秒更新显示剩余秒数。
     *
     * @note
     *    离开使用useCountdown的页面，再重新进入页面，倒计时会被重置，
     *    如果需要离开倒计时不重置的话, 外部需要保存isStarted与remaining，在进入是
     *      -Gim
     *
     * @param inits 初始化参数。
  
     * @returns {Result}
     */
    function use(inits) {
        var _a, _b, _c, _d;
        var preIsStarted = (0, react_1.useRef)(inits.started);
        var resetMode = (_a = inits.resetMode) !== null && _a !== void 0 ? _a : 'beforeStart';
        var _e = (0, react_1.useState)((_b = inits.duration) !== null && _b !== void 0 ? _b : 60), duration = _e[0], setDuration = _e[1];
        var _f = (0, react_1.useState)((_c = inits.started) !== null && _c !== void 0 ? _c : true), isStarted = _f[0], setIsStarted = _f[1];
        var _g = (0, react_1.useState)((_d = inits.remaining) !== null && _d !== void 0 ? _d : duration), remaining = _g[0], setRemaining = _g[1];
        (0, react_1.useEffect)(function () {
            if (isStarted !== preIsStarted.current) {
                if (isStarted && resetMode === 'beforeStart') {
                    setRemaining(duration);
                }
                preIsStarted.current = isStarted;
            }
            if (!isStarted) {
                if (resetMode !== 'beforeStart') {
                    setRemaining(duration);
                }
                return;
            }
            var onTick = function () { return setRemaining(function (v) {
                if (v <= 1) {
                    if (resetMode === 'afterEnd') {
                        setRemaining(duration);
                    }
                    setIsStarted(false);
                    clearInterval(timerId);
                }
                return Math.max(0, v - 1);
            }); };
            var timerId = setInterval(onTick, 1000);
            return function () { return clearInterval(timerId); };
        }, [isStarted, duration]);
        return {
            remaining: remaining,
            setRemaining: setRemaining,
            duration: duration,
            setDuration: setDuration,
            isStarted: isStarted,
            setIsStarted: setIsStarted,
        };
    }
    Countdown.use = use;
})(Countdown = exports.Countdown || (exports.Countdown = {}));
//# sourceMappingURL=index.js.map